export default __webpack_public_path__ + "static/media/sound.273dabe3.flac";